import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import React from 'react';
export const KotoToggle = (props) => {
  return <Toggle {...props} />;
};

export default KotoToggle;
